import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/bnafar-relatorio-envio`

    return {
        index(params) {
            return repository.post(`${baseUrl}`, params)
        },
        create(queryParms) {
            return repository.get(`${baseUrl}/create`, queryParms)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}